import React, { Fragment } from 'react';
import { If } from 'common/src/components';
import { UserAvatar } from 'businessCommon/src/components';
import { Iconfont } from '@umu/umu-design';
import { SELECTED_CARD } from '../../type';
import { getAvatar, getName } from '../../util';

interface IProps {
    item: SELECTED_CARD;
    removeSelectedItem: (item: SELECTED_CARD) => void;
}
export const SelectedItem = ({ item, removeSelectedItem }: IProps) => {
    const selectedUserItem = (user: SELECTED_CARD) => (
        <div className="selected-card flex--start--center">
            <UserAvatar className="avatar" width={21} src={getAvatar(user)} />
            <span className="umu-text-clamp clamp-1">{getName(user)}</span>
            <span className="selected-delete-btn" onClick={() => removeSelectedItem(item)}>
                <Iconfont type="Close" />
            </span>
        </div>
    );
    return (
        <Fragment>
            {item.account_type !== 'keyword' ? selectedUserItem(item) : ''}
            <If condition={item.account_type === 'keyword'}>
                <div className="selected-card flex--start--center keyword">
                    {item.account}
                    <span className="selected-delete-btn" onClick={() => removeSelectedItem(item)}>
                        <Iconfont type="Close" />
                    </span>
                </div>
            </If>
        </Fragment>
    );
};
